import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function issueDrawerOpened(state: WritableDraft<QuoteBuilderStateType>) {
  state.isIssueDrawerOpen = true;
}
